
const appConfig = {
	host: 'https://zipteam.wpenginepowered.com/',
    prefix: 'wp-json',
};

export default appConfig;
